<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-4 col-md-3 col-lg-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="..."
          @click="handleClickOnCode('Categorías')"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-8 col-md-9 col-lg-10">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          placeholder="..."
        >
        </fg-input>
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.description') }}:</label>
          <br />
          <el-input
            maxlength="200"
            show-word-limit
            type="textarea"
            :rows="2"
            placeholder="..."
            v-model="model.description"
            class="shadow-sm"
          ></el-input>
          <br />
          <br />
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        id: null,
        name: null,
        code: null,
        description: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
      },
      categories: [],
    };
  },
  mixins: [MixinPermissions, MixinForm],
  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', this.model);
        return res;
      });
    },
  },
  created() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const { id, name, code, description } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = { id, name, code, description };
    }
  },
};
</script>
<style></style>
